import {
    isFeatureEnabled,
    toFeatureState,
} from '@etrigan/feature-toggles-client'
import { metrics, TheWestSection } from '@news-mono/component-library'
import { StaticRoutes, Topic } from '@news-mono/web-common'
import { layout } from '../App.routing'
import { getTopicSponsor } from './topic/get-topic-sponsor'

export const pollieRater: StaticRoutes<TheWestSection> = {
    '/politics/federal-election/pollie-rater': ({
        getAdTargeting,
        store,
        config,
    }) => {
        if (
            !isFeatureEnabled(
                toFeatureState(store.getState().toggles),
                'federal-election-2022',
            )
        ) {
            return null
        }

        const canonicalUrl =
            config.publicUrl + '/politics/federal-election/pollie-rater'
        const topic: Topic = {
            id: 'politics/federal-election/pollie-rater',
            metadata: {},
            title: 'Pollie Rater',
            seoTitle: 'Pollie Rater | The West Australian',
            seoDescription: ``,
        }

        return {
            kind: 'page',
            heading: 'Pollie Rater',
            pageType: 'static',
            hideHeading: true,
            refreshOnInactive: false,
            pageMeta: {
                title: topic.title,
                description: topic.seoDescription,
                seoTitle: topic.seoTitle,
                seoDescription: topic.seoDescription,
                link: [{ rel: 'canonical', href: canonicalUrl }],
            },
            adTargeting: getAdTargeting('home', 'default', topic),
            section: 'default',
            compositions: [
                layout.composition({
                    type: 'athena',
                    props: {
                        containerWidth:
                            metrics.thewest.siteMetrics.mainContentWidth,
                        elementType: 'div',
                        sidebarOptions: 'visibleMobile',
                    },
                    contentAreas: {
                        main: [
                            layout.component({
                                type: 'breadcrumb',
                                props: {
                                    topic,
                                    sponsor: getTopicSponsor(topic),
                                    enableHeaderTag: true,
                                    verticalSpacing: 'lg',
                                },
                            }),
                        ],

                        // SIDEBAR
                        sidebar: [
                            layout.component({
                                type: 'ad-unit',
                                props: {
                                    noticePosition: 'below-center',
                                    padding: [
                                        0,
                                        0,
                                        metrics.thewest.margins.md,
                                        0,
                                    ],
                                    slot: {
                                        id: 'sidebar-top',
                                        size: 'desktopMrecHalfPage',
                                        pageType: 'static',
                                    },
                                },
                            }),
                            layout.nestedComposition({
                                type: 'box',
                                props: {
                                    stickyOffset: 350,
                                    fillContainer: true,
                                },
                                contentAreas: {
                                    main: [
                                        layout.component({
                                            type: 'fact-checker-section-header',
                                            props: {
                                                sizing: 'smaller',
                                                dataDefinitionArgs: {
                                                    type: 'listing',
                                                    topics: [
                                                        'politics/federal-election',
                                                    ],
                                                    paging: {
                                                        page: 1,
                                                        pageSize: 1,
                                                        pageOffset: 0,
                                                    },
                                                },
                                            },
                                        }),
                                        layout.component({
                                            type: 'ad-unit',
                                            props: {
                                                noticePosition: 'below-center',
                                                padding: [
                                                    0,
                                                    0,
                                                    metrics.thewest.margins.md,
                                                    0,
                                                ],
                                                slot: {
                                                    id: 'sidebar-middle',
                                                    size: 'desktopMrec',
                                                    pageType: 'static',
                                                },
                                            },
                                        }),
                                    ],
                                },
                            }),
                        ],
                    },
                }),
            ],
        }
    },
}
